import { Navigate, NavigateProps, useLocation } from "react-router";
import { FCC } from "types";

export const NavigateWithQueryParams: FCC<NavigateProps> = ({ to }) => {
  const { search } = useLocation();

  return <Navigate to={to + search} replace />;
};
